import * as React from 'react';
import useScreen from '@/hooks/useScreen';
const ExchangeIcon = (props: any) => {
  const { isDesktop } = useScreen();
  if (isDesktop) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
        <g clipPath="url(#a)">
          <mask
            id="b"
            width={20}
            height={20}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: 'alpha',
            }}
          >
            <path fill="#D9D9D9" d="M0 0h20v20H0z" />
          </mask>
          <g mask="url(#b)">
            <path
              fill="#2BAB3F"
              d="m10.05 15.654 2.191-2.178-2.19-2.178-.7.699 1.025 1.024a4.215 4.215 0 0 1-1.428-.208 2.786 2.786 0 0 1-1.098-.666 2.979 2.979 0 0 1-.667-1.006 3.022 3.022 0 0 1-.227-1.132c0-.236.028-.472.085-.708.058-.236.14-.462.245-.68l-.74-.708c-.2.32-.346.657-.441 1.01a4.026 4.026 0 0 0 .158 2.589c.2.497.495.942.884 1.334.39.392.862.685 1.419.878a5.427 5.427 0 0 0 1.713.303l-.927.928.698.699Zm3.414-3.574c.198-.32.345-.657.44-1.009a4.107 4.107 0 0 0-.151-2.596 3.83 3.83 0 0 0-.882-1.34 3.557 3.557 0 0 0-1.422-.872 5.35 5.35 0 0 0-1.72-.284l.929-.94-.699-.7-2.19 2.179 2.19 2.177.699-.698L9.62 6.96c.508 0 .986.075 1.434.227a2.8 2.8 0 0 1 1.107.662c.29.29.51.625.663 1.002.152.378.229.755.229 1.133 0 .236-.029.472-.086.708a3.333 3.333 0 0 1-.245.68l.74.708Zm-3.462 5.833a7.711 7.711 0 0 1-3.088-.623A7.997 7.997 0 0 1 4.4 15.598a7.994 7.994 0 0 1-1.692-2.513 7.705 7.705 0 0 1-.624-3.087c0-1.095.208-2.124.623-3.087A7.997 7.997 0 0 1 4.4 4.396a7.993 7.993 0 0 1 2.513-1.692A7.705 7.705 0 0 1 10 2.08c1.095 0 2.124.208 3.088.623.963.416 1.801.98 2.514 1.692a7.994 7.994 0 0 1 1.693 2.513c.415.963.623 1.992.623 3.087a7.71 7.71 0 0 1-.623 3.088 7.997 7.997 0 0 1-1.692 2.514 7.995 7.995 0 0 1-2.513 1.693 7.705 7.705 0 0 1-3.087.623Z"
            />
          </g>
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h20v20H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
      <g clipPath="url(#a)">
        <mask
          id="b"
          width={16}
          height={16}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'alpha',
          }}
        >
          <path fill="#D9D9D9" d="M0 0h16v16H0z" />
        </mask>
        <g mask="url(#b)">
          <path
            fill="#2BAB3F"
            d="m8.04 12.523 1.753-1.742L8.04 9.038l-.559.56.82.819a3.372 3.372 0 0 1-1.143-.166 2.228 2.228 0 0 1-.878-.533 2.383 2.383 0 0 1-.534-.805 2.417 2.417 0 0 1-.182-.905c0-.19.023-.378.069-.567.046-.189.11-.37.196-.544l-.593-.566a3.02 3.02 0 0 0-.352.807 3.221 3.221 0 0 0 .126 2.071c.16.398.396.754.708 1.068.311.314.69.548 1.134.702a4.34 4.34 0 0 0 1.371.243l-.742.742.56.559Zm2.73-2.859a3.02 3.02 0 0 0 .353-.807 3.285 3.285 0 0 0-.12-2.077 3.065 3.065 0 0 0-.707-1.072A2.846 2.846 0 0 0 9.16 5.01a4.28 4.28 0 0 0-1.375-.227l.742-.752-.559-.56-1.753 1.743 1.753 1.742.559-.559-.83-.83c.407 0 .79.061 1.148.182a2.24 2.24 0 0 1 1.416 1.332c.122.302.183.604.183.906 0 .189-.023.378-.069.567-.046.189-.11.37-.196.543l.593.567Zm-2.769 4.667c-.876 0-1.699-.166-2.47-.499a6.397 6.397 0 0 1-2.011-1.354 6.394 6.394 0 0 1-1.354-2.01 6.163 6.163 0 0 1-.499-2.47c0-.875.166-1.699.499-2.47a6.398 6.398 0 0 1 1.353-2.01 6.395 6.395 0 0 1 2.01-1.355A6.164 6.164 0 0 1 8 1.664c.876 0 1.7.166 2.47.499.771.332 1.442.783 2.012 1.353.57.57 1.021 1.24 1.354 2.01.332.771.499 1.594.499 2.47 0 .876-.167 1.7-.499 2.47a6.398 6.398 0 0 1-1.354 2.012 6.394 6.394 0 0 1-2.01 1.354 6.164 6.164 0 0 1-2.47.499Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.memo(ExchangeIcon);
